import script from "./StarPost.vue?vue&type=script&setup=true&lang=ts"
export * from "./StarPost.vue?vue&type=script&setup=true&lang=ts"

import "./StarPost.vue?vue&type=style&index=0&id=a8a20ec2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8a20ec2"]])

export default __exports__